import React from 'react';

export const CODE_COMPOSITION_HELP_LINES = [
  'Measures added lines on deployment-branch commits, split by whether files are new or already existed in the repo.',
  'New files — lines in files with status added.',
  'Existing changes — lines added to modified, renamed, or copied files with moderate churn.',
  'Rework — lines added to existing files where deletions are at least half of total line changes (high churn).',
  'Lockfiles, generated paths, and minified bundles are excluded.',
  'File stats populate during commit sync; historical commits may need a backfill for full coverage.',
];

export function CodeCompositionHelpContent() {
  return (
    <ul className="list-disc pl-5 space-y-2 text-sm text-slate-300">
      {CODE_COMPOSITION_HELP_LINES.map((line) => (
        <li key={line}>{line}</li>
      ))}
    </ul>
  );
}
